<template>
  <div>
    <p
      v-if="slide.overtitle"
      :style="{'color' : slide.color}"
      class="h6 overtitle"
    >{{slide.overtitle}}</p>
    <p v-if="slide.title" :style="{'color' : slide.color}" class="h1 title">{{slide.title}}</p>
    <p v-if="slide.description" class="home-slider-description" :style="{'color' : slide.color}">{{slide.description}}</p>
    <p :style="{'color' : slide.color}" class="readmore">
      <router-link
        v-if="slide.type !== 'blank'"
        :to="link"
        :style="{'color' : slide.color}"
        class="dinamo-link"
      >{{$t('message.read')}}</router-link>
      <a
        v-else
        :href="slide.ref"
        target="_blank"
        :style="{'color' : slide.color}"
        class="dinamo-link"
      >{{$t('message.read')}}</a>
    </p>
  </div>
</template>
<script>
export default {
  props: {
    link: {
      default: () => {}
    },
    slide: {
      default: () => {}
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@assets/scss/_importer.scss";
.home-slider-description {
  display: none;
  @media screen and (min-width: 400px) {
    display: block;
  }
}
p {
  font-weight: $global-weight-bold;
  margin-bottom: 0;
  & + p {
    margin-top: 16px;
  }
  &.overtitle {
    text-transform: uppercase;
    @include breakpoint(small only) {
      font-size: 1.2rem;
    }
  }
  &.title {
    @include breakpoint(small only) {
      font-size: 2rem;
    }
  }
  &.readmore {
    margin-top: 32px;
    a {
      font-size: 18px;
      line-height: 20px;
      text-decoration: underline;
    }
  }
}
</style>